import React from 'react';
import { useTheme, Box, BoxProps } from '@material-ui/core';

export const CallsManSVG = ({ ...props }: BoxProps) => {
    const theme = useTheme();

    const fillColor = theme.palette.primary.main;

    return (
        <Box {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="100%"
                height="100%"
                viewBox="0 0 500.713 800.054"
                role="img"
                data-artist="Katerina Limpitsouni"
                data-source="https://undraw.co/"
            >
                <g transform="translate(-577.567 -45.973)">
                    <g transform="translate(-133.014 -94)">
                        <path
                            d="M665.294,269.316h-4.4V148.89a69.7,69.7,0,0,0-69.7-69.7H336.062a69.7,69.7,0,0,0-69.7,69.7V809.551a69.7,69.7,0,0,0,69.7,69.7H591.2a69.7,69.7,0,0,0,69.7-69.7V355.035h4.4Z"
                            transform="translate(546 60.78)"
                            fill="#090814"
                        />
                        <path
                            d="M592.274,95.686h-33.3a24.729,24.729,0,0,1-22.9,34.069H389.9a24.729,24.729,0,0,1-22.9-34.069H335.9a52.051,52.051,0,0,0-52.051,52.051V807.429A52.051,52.051,0,0,0,335.9,859.479H592.264a52.051,52.051,0,0,0,52.051-52.051V147.737a52.051,52.051,0,0,0-52.039-52.051Z"
                            transform="translate(547.746 62.421)"
                            fill="#fff"
                        />
                    </g>
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(742.815 423.048)"
                        fill={fillColor}
                    />
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(838.815 423.048)"
                        fill="#d6d6e3"
                    />
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(934.815 423.048)"
                        fill="#d6d6e3"
                    />
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(742.815 561.458)"
                        fill="#d6d6e3"
                    />
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(838.815 561.458)"
                        fill="#d6d6e3"
                    />
                    <circle
                        cx="40"
                        cy="40"
                        r="40"
                        transform="translate(934.815 561.458)"
                        fill="#f2f2f2"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(-77.708 324.345)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(18.292 324.345)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(114.292 324.345)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(-77.708 462.756)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(18.292 462.756)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M881.078,194.2H839.969c-.741,0-1.341-1.408-1.341-3.145s.6-3.145,1.341-3.145h41.108c.741,0,1.341,1.408,1.341,3.145s-.6,3.145-1.341,3.145Z"
                        transform="translate(114.292 462.756)"
                        fill="#d6d6e3"
                    />
                    <path
                        d="M217.977,231.132c-4.821,0-8.729,9.443-8.729,21.091s3.908,21.091,8.729,21.091H367.041c4.821,0,8.729-9.443,8.729-21.091s-3.908-21.091-8.729-21.091Z"
                        transform="translate(586.307 -29.893)"
                        fill={fillColor}
                    />
                    <path
                        d="M14.516,3a1.779,1.779,0,0,1,1.568.961l.091.2,3.576,9.259a1.893,1.893,0,0,1-.56,2.148l-.179.126L16.02,17.558l.113.191a18.213,18.213,0,0,0,5.6,5.8l.182.115,1.8-3.1a1.762,1.762,0,0,1,1.99-.839l.206.072,8.94,3.7A1.843,1.843,0,0,1,35.96,25l.013.224V32.63A5.478,5.478,0,0,1,30.5,38.182C15.162,37.217,2.933,24.552,2,8.556A5.476,5.476,0,0,1,7.05,3.009L7.364,3h7.152Z"
                        transform="matrix(-0.695, 0.719, -0.719, -0.695, 1002.816, 602.104)"
                        fill="#090814"
                    />
                    <g transform="translate(577.567 393.773)">
                        <path
                            d="M949.866,389.156c4.843,14.337,12.268,27.4,27.4,27.4s26.548-12.292,27.4-27.4c1.09-19.307-11.919-27.481-27.4-27.4C958.977,361.85,944.119,372.141,949.866,389.156Z"
                            transform="translate(-921.792 -361.755)"
                            fill="#090814"
                        />
                        <rect
                            width="54.081"
                            height="68.503"
                            transform="translate(28.794 26.786)"
                            fill="#2f2e41"
                        />
                        <path
                            d="M1016.733,440.527h-4.6A40.95,40.95,0,0,0,1006,474.26c5.111,19.422,1.022,23,1.022,23s-6.654,21.032.5,52.721-6.635,40.3-6.635,40.3l12.778-25.555,7.155-67.466Z"
                            transform="translate(-989.526 -362.707)"
                            fill="#9f616a"
                        />
                        <path
                            d="M972.031,415.435s4.089,16.355,2.044,16.355-9.2,8.689-9.2,8.689l-4.6,16.866,3.578,12.267,12.267-2.556,15.333-16.866,4.6-4.6,4.089-14.822s-5.111-6.133-1.533-11.244S972.031,415.435,972.031,415.435Z"
                            transform="translate(-928.725 -362.403)"
                            fill="#9f616a"
                        />
                        <path
                            d="M829,461.02l11.244-18.4s12.138-26.856,20.826-17.145-13.16,29.411-13.16,29.411l-11.244,14.822Z"
                            transform="translate(-662.006 -362.499)"
                            fill="#9f616a"
                        />
                        <path
                            d="M950.446,623.258l8.178,59.8s-1.022,4.6,9.2,21.466,37.822,53.666,37.822,53.666l8.178-15.333s-9.711-48.555-26.577-58.777l2.044-73.6Z"
                            transform="translate(-932.695 -364.762)"
                            fill="#9f616a"
                        />
                        <path
                            d="M936.871,738.268l-11.244,21.466s9.2,12.916,5.622,15.472-8.178,25.555,1.533,23,17.378-12.778,17.378-14.311-5.622-9.85-2.555-14.961,5.111-6.644,5.111-6.644l6.12,8.136,2.555-1.533L950.16,752.068s-1.533-4.089-7.667-6.644Z"
                            transform="translate(-855.743 -366.307)"
                            fill="#090814"
                        />
                        <path
                            d="M935.313,614.773s-3.97,56.528,4.719,71.35v73.6l11.755,1.533s23.74-38.965,15.051-77.3,8.971-73.478,8.971-73.478Z"
                            transform="translate(-878.837 -364.762)"
                            fill="#9f616a"
                        />
                        <ellipse
                            cx="21.466"
                            cy="21.466"
                            rx="21.466"
                            ry="21.466"
                            transform="translate(37.94 22.622)"
                            fill="#9f616a"
                        />
                        <path
                            d="M876.682,463.118l21.466-27.089,12.266-8.178,5.111,6.644,14.311,4.089s9.2,2.044,18.911,13.289,27.088,17.889,27.088,17.889,31.177-10.222,31.177-12.267,14.822,13.8,11.244,19.933-20.63,24.871-45.674,21.294-34.569-6.983-34.569-6.983-4.6,23.511-17.889,28.111-56.733,7.667-56.733,7.667l-9.2-30.666s-10.222-13.289,3.578-32.711c0,0,.265-10.862,1.749-18.09.577-2.811,1.338-5.073,2.34-5.932,3.578-3.067,22.489-8.178,22.489-8.178s-3.067,10.222-4.6,10.733S874.637,460.563,876.682,463.118Z"
                            transform="translate(-838.997 -362.554)"
                            fill={fillColor}
                        />
                        <path
                            d="M1019.657,676.335c-25.739-1.789-40.725,2.428-47.41,5.643-1.243.562-5.879,1.742-5.879,1.936,0,1.533-33.634,5.387-46.412,2.321S931.775,558,937.4,552.374s2.591-26.2,2.591-26.2,51.586-7.023,56.186-8.045c2.055-.455,3.092.312,3.608,1.3a8.838,8.838,0,0,0,3.5,3.532c10.851,6.251,19.56,49.47,26.117,73.364C1036.551,622.395,1019.657,676.335,1019.657,676.335Z"
                            transform="translate(-916.323 -363.644)"
                            fill="#090814"
                        />
                        <path
                            d="M979.943,756.892s-6.012,21.96-9.711,39.355c0,0-2.556,6.037-11.755,10.637s1.561,12.239,10.25,11.728,16.866.511,17.889-2.044,4.061-13.676,4.061-13.676l1.678,15.383,5.111.511L995.787,798.8s4.089-7.667-1.533-20.444l1.419-19.613S981.476,762,979.943,756.892Z"
                            transform="translate(-920.792 -366.532)"
                            fill="#090814"
                        />
                        <path
                            d="M977.181,623.308a16.944,16.944,0,0,0-3.486,2.116c-.271-4.83-1.835-34.04.041-33.569Z"
                            transform="translate(-918.164 -364.537)"
                            opacity="0.1"
                            data-style="isolation:isolate"
                        />
                        <path
                            d="M990.231,376.434s.238-1.323,9.535,2.163,14.871,29.217,10.222,44.325c-1.873,6.089-.349,10.479,2.138,13.55,9.334,11.527,5.66,28.839-7.936,34.766q-.576.251-1.175.5l-5.811,3.487s7.408-9.747,3.7-22.216a63.927,63.927,0,0,1-1.154-32.726c.425-1.826.909-3.708,1.457-5.629,4.649-16.271,2.388-14.392-13.883-30.663,0,0-9.3,6.973-17.433,10.46s-15.109,6.973-9.3,18.6,19.758,22.082,10.46,37.191-10.46,9.3-9.3,15.109h0l1.162,5.811-6.973-6.973,4.649,9.3s-15.109,0-19.758-11.622l-2.324,2.324s-9.3-16.271,8.135-31.38c0,0,5.811-3.487-2.324-15.109s-1.887-36.61,8.573-41.259S990.231,376.434,990.231,376.434Z"
                            transform="translate(-921.938 -361.907)"
                            fill="#090814"
                        />
                    </g>
                </g>
            </svg>
        </Box>
    );
};
